

















import { Component, Mixins, Watch } from "vue-property-decorator";
import FolderTableSelector from "./FolderTableSelector.vue";
import FolderEditDialog from "./FolderEditDialog.vue";
import FileListView from "../file/FileListView.vue";
import Separator from "../system/Separator.vue";
import FolderListMixin from "./mixins/FolderListMixin.vue";
import { Folder } from "@/domain/folder";
import Enumerable from "linq";

@Component({
  components: {
    FolderTableSelector,
    FolderEditDialog,
    Separator,
    FileListView,
  }
})
export default class FolderListView extends Mixins(FolderListMixin) {
  data() {
    return {
      selectedFolder: null as Folder,
      selectorWidth: 650,
      folders: [] as Folder[],
      isDialogVisible: false,
      isDialogEdit: false,
    };
  }
  selectedFolder: Folder;
  selectorWidth: number;
  folders: Folder[];
  isDialogVisible: boolean;
  isDialogEdit: boolean;

  created(): void {
    this.refresh();
    this.setDefaultSelectorWidth();
  }

  get selectedGuid(): string {
    return !!this.selectedFolder
      ? this.selectedFolder.guid
      : "";
  }

  @Watch("folders")
  onFoldersUpdated(newValue: Folder[], oldValue: Folder[]): void {
    this.selectedFolder = null;
  }

  selectionChanged(value: Folder): void {
    this.selectedFolder = value;
  }

  addFolder(): void {
    this.isDialogEdit = false;
    this.isDialogVisible = true;
  }

  editFolder(): void {
    this.isDialogEdit = true;
    this.isDialogVisible = true;
  }

  refresh(): void {
    this.getFolderList().then(l => {
      this.folders = Enumerable.from(l)
        .orderByDescending(f => f.createDateTime).toArray();
    });
  }

  filesChanged(): void {
    this.getFolderInfo(this.selectedGuid).then((f) => {
      // 配列を置き換えると一覧の表示状態もクリアされるため値のみ変更する
      const folder = this.folders.find(v => v.guid === f.guid);
      if (!folder) {
        return;
      }
      folder.size = f.size;
    });
  }

  async editConfirm(value: Folder): Promise<void> {
    if (this.isDialogEdit) {
      await this.updateFolder(value);
    } else {
      await this.createFolder(value);
    }
    this.refresh();
  }

  deleteSelectedFolder(): void {
    this.$confirm("削除してもよろしいですか？", "フォルダ削除", { confirmButtonText: "削除", cancelButtonText: "取消" })
    .then(() => {
      this.deleteFolder(this.selectedGuid).then(() => {
        this.refresh();
      });
    })
    .catch((e) => {
      return; // キャンセル
    });
  }

  private setDefaultSelectorWidth(): void {
    this.selectorWidth = Math.max(300, window.innerWidth - 750);
  }
}
